/** 监控模式 */
export enum SpyMode {
  /** 智能监控 */
  smart = 2,
  /** 普通监控 */
  normal = 5,
  /** 全盘监控v2（执行+创建修改） */
  fullV2 = 3,
  /** 全盘监控v3（所有操作） */
  fullV3 = 4
}
